import { widePageContainer } from "../styles";

interface Props {
  rows?: number;
}

export default function PageLoader({ rows = 4 }: Props) {
  return (
    <div className="sg-fade-in" style={{ ...widePageContainer, padding: "1.5rem 0" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            className="sg-skeleton"
            style={{
              height: i === 0 ? 56 : 96,
              animationDelay: `${i * 0.08}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
